import { useTranslation } from 'react-i18next';
import {
  Backdrop,
  ButtonRow,
  LogoutPopupContainer,
} from './GlobalComponentStyles';
import React, { SetStateAction } from 'react';
import { Button } from 'react-bootstrap';
import { LogOut, X } from 'lucide-react';

const LogoutPopup = ({
  handleLogout,
  setOpenModal,
}: {
  handleLogout: () => void;
  setOpenModal: React.Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  return (
    <Backdrop onClick={() => setOpenModal(false)}>
      <LogoutPopupContainer
        role='dialog'
        aria-modal='true'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='d-flex justify-content-between'>
          <h3 className='mb-0 font-size-1-point-125 font-weight-600'>
            {t('logout')}
          </h3>
          <X cursor={'pointer'} onClick={() => setOpenModal(false)} size={20} />
        </div>
        <p className='mb-0 ml-2 font-size-point-875-rem fw-400'>
          {t('logout_confirmation_msg')}
        </p>

        <ButtonRow>
          <Button
            size='sm'
            className='filter-btn px-3 py-2'
            onClick={() => setOpenModal(false)}
          >
            <X color='var(--font-color)' size={20} />
            {t('cancel')}
          </Button>
          <Button
            size='sm'
            className='px-3 py-2 font-size-point-875-rem shadow-none border-0'
            style={{
              backgroundColor: 'var(--primary-color)',
              color: 'var(--primary-foreground)',
              borderRadius: '6px',
            }}
            onClick={handleLogout}
          >
            <LogOut size={20} className='mr-2' />
            {t('logout')}
          </Button>
        </ButtonRow>
      </LogoutPopupContainer>
    </Backdrop>
  );
};

export default LogoutPopup;
